export default __webpack_public_path__ + "static/media/suco-natural.4f2d223f.jpg";